import type { CandidateRequirementsDTO } from '@/entities/questionnaire';
import { QuestionKey } from '@/entities/questionnaire';

export function getShouldShowQuestion(
  requirements: CandidateRequirementsDTO | undefined,
  questionKey: QuestionKey,
): boolean {
  if (!requirements) return false;
  const shouldShow = requirements[questionKey].job_requirements;

  if (!shouldShow || (Array.isArray(shouldShow) && shouldShow.length === 0)) return false;

  return true;
}

export function buildQuestionnaireState(requirements: CandidateRequirementsDTO): CandidateRequirementsDTO {
  return {
    [QuestionKey.READY_FOR_JOB_OFFERS]: {
      ...requirements[QuestionKey.READY_FOR_JOB_OFFERS],
      is_required:
        requirements[QuestionKey.READY_FOR_JOB_OFFERS]?.is_required ??
        getShouldShowQuestion(requirements, QuestionKey.READY_FOR_JOB_OFFERS),
    },
    [QuestionKey.CERTIFICATES_AND_LICENSES]: {
      ...requirements[QuestionKey.CERTIFICATES_AND_LICENSES],
      is_required:
        requirements[QuestionKey.CERTIFICATES_AND_LICENSES]?.is_required ??
        getShouldShowQuestion(requirements, QuestionKey.CERTIFICATES_AND_LICENSES),
    },
    [QuestionKey.SALARY]: {
      ...requirements[QuestionKey.SALARY],
      is_required:
        requirements[QuestionKey.SALARY]?.is_required ?? getShouldShowQuestion(requirements, QuestionKey.SALARY),
    },
    [QuestionKey.SHIFTS]: {
      ...requirements[QuestionKey.SHIFTS],
      is_required:
        requirements[QuestionKey.SHIFTS]?.is_required ?? getShouldShowQuestion(requirements, QuestionKey.SHIFTS),
    },
    [QuestionKey.AVAILABLE_DAYS]: {
      ...requirements[QuestionKey.AVAILABLE_DAYS],
      is_required:
        requirements[QuestionKey.AVAILABLE_DAYS]?.is_required ??
        getShouldShowQuestion(requirements, QuestionKey.AVAILABLE_DAYS),
    },
    [QuestionKey.LIMITATIONS_AND_PREFERENCES]: {
      ...requirements[QuestionKey.LIMITATIONS_AND_PREFERENCES],
      is_required:
        requirements[QuestionKey.LIMITATIONS_AND_PREFERENCES]?.is_required ??
        getShouldShowQuestion(requirements, QuestionKey.LIMITATIONS_AND_PREFERENCES),
    },
    [QuestionKey.WORKING_HOURS_PER_WEEK]: {
      ...requirements[QuestionKey.WORKING_HOURS_PER_WEEK],
      is_required:
        requirements[QuestionKey.WORKING_HOURS_PER_WEEK]?.is_required ??
        getShouldShowQuestion(requirements, QuestionKey.WORKING_HOURS_PER_WEEK),
    },
    [QuestionKey.LANGUAGES]: {
      ...requirements[QuestionKey.LANGUAGES],
      is_required:
        requirements[QuestionKey.LANGUAGES]?.is_required ?? getShouldShowQuestion(requirements, QuestionKey.LANGUAGES),
    },
  };
}
